var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SampleForm',{attrs:{"sample":_vm.sample,"buttonLoading":_vm.buttonLoading},on:{"saveSample":_vm.saveSample}})
}
var staticRenderFns = []

export { render, staticRenderFns }